<template>
  <div class="container">
    <div v-if="entityType">
      <p>Audit trail for {{ $route.params.type }} with id: {{ $route.params.id }}</p>

      <v-data-table :headers="entityType.headers" :items="auditTrail.data" must-sort hide-actions item-key="version" :loading="loading">
        <template slot="items" slot-scope="audit">
          <!-- AUCTION -->
          <tr v-if="$route.params.type === 'auction'">
            <td>
              {{ audit.item.version }}
            </td>
            <td>
              {{ audit.item.start|prettyDateTime }}
            </td>
            <td>
              {{ audit.item.modified_by }}
            </td>
            <td>
              {{ audit.item.status }}
            </td>
            <td>
              {{ audit.item.current_price|prettyMoney }}
            </td>
            <td>
              {{ audit.item.last_bidder }}
            </td>
            <td>
              {{ audit.item.end_date|prettyDateTime }}
            </td>
          </tr>
          <!-- AUCTION_ROLE -->
          <tr v-if="$route.params.type === 'auction_role'">
            <td>
              {{ audit.item.version }}
            </td>
            <td>
              {{ audit.item.start|prettyDateTime }}
            </td>
            <td>
              {{ audit.item.modified_by }}
            </td>
            <td>
              {{ audit.item.auction_id }}
            </td>
            <td>
              {{ audit.item.user_id }}
            </td>
            <td>
              {{ audit.item.role }}
            </td>
          </tr>
          <!-- AUTO_BID -->
          <tr v-if="$route.params.type === 'auto_bid'">
            <td>
              {{ audit.item.version }}
            </td>
            <td>
              {{ audit.item.start|prettyDateTime }}
            </td>
            <td>
              {{ audit.item.modified_by }}
            </td>
            <td>
              {{ audit.item.id }}
            </td>
            <td>
              {{ audit.item.increment }}
            </td>
            <td>
              {{ audit.item.threshold }}
            </td>
            <td>
              {{ audit.item.last_bid }}
            </td>
            <td>
              {{ audit.item.status }}
            </td>
          </tr>
        </template>
        <template slot="no-data">
          {{ loading ? '' : '(Audit data not available)' }}
        </template>
      </v-data-table>

    </div>
    <div v-else>
      Parameter error
    </div>
  </div>
</template>

<script>
  const meta = {
    auction: {
      headers: [
        { text: 'Version', sortable: false },
        { text: 'Date', sortable: true, value: 'start' },
        { text: 'Modified By', sortable: false },
        { text: 'Status', sortable: false },
        { text: 'Price', sortable: false },
        { text: 'Last bidder', sortable: false },
        { text: 'Auction End', sortable: false }
      ]
    },
    auction_role: {
      headers: [
        { text: 'Version', sortable: false },
        { text: 'Date', sortable: true, value: 'start' },
        { text: 'Modified By', sortable: false },
        { text: 'Auction', sortable: false },
        { text: 'User', sortable: false },
        { text: 'Role', sortable: false }
      ]
    },
    auto_bid: {
      headers: [
        { text: 'Version', sortable: false },
        { text: 'Date', sortable: true, value: 'start' },
        { text: 'Modified By', sortable: false },
        { text: 'Auction Role', sortable: false },
        { text: 'Increment', sortable: false },
        { text: 'Threshold', sortable: false },
        { text: 'Last bid', sortable: false },
        { text: 'status', sortable: false }
      ]
    }
  }

  export default {
    name: 'AuditTrailPage',
    data() {
      return {
        auditTrail: [],
        loading: false
      }
    },
    computed: {
      entityType() {
        return meta[this.$route.params.type]
      }
    },
    mounted() {
      if (!this.entityType) {
        this.$notify({ type: 'danger', message: 'Unsupported type' })
        return
      }
      this.loading = true
      this.$PfxBackendApi
        .getAuditTrailData(
          this.$route.params.type,
          this.$route.params.id
        )
        .then(res => {
          this.auditTrail = res.data
        })
        .catch(err => {
          this.$notify({ type: 'danger', message: err.message })
        })
        .then(() => {
          this.loading = false
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AuditTrailPage.vue